<template>
  <el-menu
    default-active="1-4-1"
    class="el-menu-vertical-demo"
    :collapse="isCollapse"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b"
    :unique-opened="true"
  >
    <h3 class="big-title">{{ isCollapse ? "后台" : "海外后台管理系统" }}</h3>
    <sidebarItem
      v-for="route in menuData"
      :key="route.id"
      :item="route"
      :base-path="route.path"
    />
  </el-menu>
</template>

<script>
import sidebarItem from "@/components/aside/SideBarItem.vue";
export default {
  components: {
    sidebarItem,
  },
  data() {
    return {
      menuRoute: [],
    };
  },

  mounted() {
    // if (this.$store.state.tab.menu.length) {
    //   this.menuRoute = this.$store.state.tab.menu;
    // } else {
    //   this.menuRoute = JSON.parse(localStorage.getItem("menu"));
    // }
  },
  computed: {
    menuData() {
      let result = [];
      result =
        JSON.parse(localStorage.getItem("menu")) || this.$store.state.tab.menu;
      return result;
    },
    isCollapse() {
      return this.$store.state.tab.isCollapse;
    },
  },
};
</script>

<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.el-menu {
  height: 100vh;
  border-right: none;
  h3 {
    color: #fff;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-weight: 400;
  }
}
.sub-menu-title {
  span {
    font-size: 15px;
    font-weight: 600;
  }
}
.menu-item-sub {
  padding-left: 48px !important;
  font-weight: 600 !important;
}
.el-menu {
  .big-title {
    font-size: 16px;
    font-weight: 600;
  }
}

/deep/ .el-submenu__title i {
  color: #fff !important;
}
</style>
